import axios from 'axios';

import { TResponse } from '@r1-frontend/do-request/core/types';
import { captureQueryError } from '@r1-frontend/do-request/error';

interface IAppleSession {
    displayName: string,
    domainName: string,
    epochTimestamp: number,
    expiresAt: number,
    merchantIdentifier: string,
    merchantSessionIdentifier: string,
    nonce: string,
    operationalAnalyticsIdentifier: string,
    retries: number,
    signature: string,
}

export type TDataResponse = TResponse<IAppleSession, any>;

/**
 * Запрос в pages/api/authorizeApplePaySession
 */

export const fetchAuthorizeApplePaySession = async(domain: string): Promise<TDataResponse> => {
    const url = '/api/apple-pay-session';

    const headers = {
        'Domain': domain,
        'Content-Type': 'application/json',
    };

    try {
        const resp = await axios({
            url,
            method: 'GET',
            headers,
        });

        return {
            isSuccess: true,
            payload: resp.data,
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
